import { defineStore } from "pinia"
import { ref, computed } from "vue"
import type { components } from "@/assets/api/openapi"

export const useOperationAdditionalDataPugStore = defineStore(
  "operationAdditionalDataPug",
  () => {
    const data = ref<components["schemas"]["OperationAdditionalDataPug"]>()
    const currentOperationId = ref<string>()
    const { startLoading, stopLoading, isLoading } = useLoading()

    const hasDataForOperation = computed(
      () => (operationId: string) =>
        data.value && currentOperationId.value === operationId
    )

    const fetchIfNeeded = async (operationId: string, force?: boolean) => {
      if (hasDataForOperation.value(operationId) && !force) {
        return data.value
      }
      return await fetchData(operationId)
    }

    const fetchData = async (operationId: string) => {
      startLoading()

      try {
        const { getOperationAdditionalDataPugByOperationId } = useAppApi()

        const response =
          await getOperationAdditionalDataPugByOperationId(operationId)

        data.value = response.data
        currentOperationId.value = operationId

        return data.value
      } catch {
        showError({
          statusCode: 500,
        })
      } finally {
        stopLoading()
      }
    }

    const clearData = () => {
      data.value = undefined
      currentOperationId.value = undefined
    }

    return {
      data: readonly(data),
      currentOperationId: readonly(currentOperationId),
      loading: readonly(isLoading),

      hasDataForOperation,
      fetchIfNeeded,
      fetchData,
      clearData,
    }
  }
)
